import { useState } from "react";
import { FiChevronDown } from "react-icons/fi";
import ReactMarkdown from "react-markdown";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    
    {
      question: "What is Advent of Apex?",
      answer: `Advent of Apex is a 25-day coding event where you solve daily Salesforce development challenges wrapped in a heartwarming holiday story. Each day from December 1-25, a new challenge drops at 9:00 AM EST, allowing you to sharpen your skills while celebrating the season.`,
    },
    {
      question: "When do challenges drop?",
      answer: `New challenges release daily at 9:00 AM EST (14:00 UTC) from December 1st through December 25th.`,
    },
        {
      question: "Why this theme?",
      answer: `I'm quite literally having a baby this month - and I thought this would be a good way to celebrate and honor the new addition to my life.`,
    },
    {
      question: "How are points calculated?",
      answer: `Points are awarded when you successfully complete a challenge by passing all test scenarios. Each challenge has a predetermined point value. Your total points and completed challenges determine your position on the leaderboard.`,
    },
    {
      question: "How do donations work?",
      answer: `100% of donations go directly to Minnie's Food Pantry, where every dollar provides 3 meals for those in need. You can donate at any time during the event. Donations are not required to participate, but they help us make a real difference in our community while celebrating the season of giving.`,
    },
    {
      question: "Can I complete challenges after their release date?",
      answer: `Yes! While new challenges release daily, you can complete previous challenges at any time during the event period (December 1-25). This makes it easy to catch up if you miss a day or want to work at your own pace. All challenges remain available until the event concludes.`,
    },
    {
      question: "Do I need a Salesforce org to participate?",
      answer: `Yes, you'll need access to a Salesforce org to complete the challenges. A free Developer Edition org is perfect for this! If you don't have one yet, you can sign up for free at developer.salesforce.com. This gives you everything you need to practice and complete all the challenges.`,
    },
    {
      question: "How do I get started?",
      answer: `Simply create an account or log in when the event begins on December 1st. The first challenge will be available at 9:00 AM EST. Read the story, understand the technical requirements, and submit your solution. Your points and progress will be tracked automatically on the leaderboard.`,
    },
    {
      question: "Can I modify my solution after submitting?",
      answer: `Yes! You can modify and resubmit your solutions at any time. The system will keep track of your latest submission and attempts.`,
    },
    {
      question: "Can I collaborate with others?",
      answer: `While we encourage learning together and discussing approaches, each submission should be your own work. Feel free to join community discussions, share insights, and help each other understand concepts. Just make sure your final solution represents your own understanding and effort.`,
    },
    {
      question: "What happens if I'm stuck on a challenge?",
      answer: `If you're stuck, review the test cases carefully and try different approaches. Join us on [Camp Apex Slack](https://join.slack.com/t/campapexorg/shared_invite/zt-2x349b383-zEistSk09EI79TBm8TIkjw) where you can ask questions, get help, and help others.`,
    },
    {
      question: "I think I found a bug",
      answer: `If you think you found one, let me know in Slack or [here](https://tally.so/r/mDzZVj)`,
    },
  ];

  return (
    <div className="space-y-6">
      <h2 className="font-['Cabin_Sketch'] text-4xl md:text-5xl text-[#D32F2F] font-bold mb-8 text-center text-shadow-vintage">
        ❓ Frequently Asked Questions
      </h2>

      {faqs.map((faq, index) => (
        <div
          key={index}
          className="bg-white rounded-2xl shadow-lg border-4 border-[#FFD700] overflow-hidden transition-all duration-300"
        >
          <button
            className="w-full p-6 text-left flex items-center justify-between bg-gradient-to-r from-[#FFF9E6] to-[#FFE8CC] hover:from-[#FFE8CC] hover:to-[#FFDAB9] transition-colors duration-300"
            onClick={() => setOpenIndex(openIndex === index ? null : index)}
          >
            <span className="text-[#3E2723] font-bold text-lg md:text-xl pr-4">
              {faq.question}
            </span>
            <FiChevronDown
              className={`text-[#D32F2F] flex-shrink-0 transform transition-transform duration-300 ${
                openIndex === index ? "rotate-180" : ""
              }`}
              size={28}
            />
          </button>
          <div
            className={`overflow-hidden transition-all duration-300 ${
              openIndex === index ? "max-h-[500px]" : "max-h-0"
            }`}
          >
            <div className="p-6 text-[#3E2723] bg-white border-t-3 border-[#FFF9C4] prose prose-lg max-w-none">
              <ReactMarkdown
                components={{
                  p: ({ node, ...props }) => (
                    <p
                      className="text-[#3E2723] leading-relaxed font-semibold mb-4"
                      {...props}
                    />
                  ),
                  a: ({ node, ...props }) => (
                    <a
                      className="text-[#D32F2F] hover:text-[#A91D1D] font-bold underline"
                      target="_blank"
                      rel="noopener noreferrer"
                      {...props}
                    />
                  ),
                  strong: ({ node, ...props }) => (
                    <strong
                      className="text-[#1B5E20] font-extrabold"
                      {...props}
                    />
                  ),
                }}
              >
                {faq.answer}
              </ReactMarkdown>
            </div>
          </div>
        </div>
      ))}

      <style jsx>{`
        .text-shadow-vintage {
          text-shadow: 3px 3px 0px #ffd700;
        }

        .border-3 {
          border-width: 3px;
        }
      `}</style>
    </div>
  );
};

export default FAQ;
